import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_MARK = "https://customer-assets-lqy194kg.emergentagent.net/job_sonic-pro-1/artifacts/fzpw1wbx_EOVO-Logo-Transparent-BasicIcon.png";
export const LOGO_FULL = "https://customer-assets.emergentagent.com/job_sonic-pro-1/artifacts/2weiwbso_EOVO-Logo-Transparent.png";

export const api = axios.create({ baseURL: API, withCredentials: true });

export function resolveAudio(src) {
  if (!src) return null;
  if (src.startsWith("http")) return src;
  return `${API}/files/${src}`;
}

export function optimizeImg(url, width = 800, quality = 70) {
  if (!url || typeof url !== "string" || !url.startsWith("http")) return url;
  try {
    const u = new URL(url);
    if (u.hostname.includes("pexels.com")) {
      u.searchParams.set("auto", "compress");
      u.searchParams.set("cs", "tinysrgb");
      u.searchParams.set("w", String(width));
      return u.toString();
    }
    if (u.hostname.includes("unsplash.com")) {
      u.searchParams.set("w", String(width));
      u.searchParams.set("q", String(quality));
      u.searchParams.set("auto", "format");
      u.searchParams.set("fit", "crop");
      return u.toString();
    }
    return url;
  } catch {
    return url;
  }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
